/* eslint-disable @octopusdeploy/custom-portal-rules/no-restricted-imports */
import { css } from "@emotion/css";
import { Fade } from "@material-ui/core";
import MuiPopover from "@material-ui/core/Popover";
import type { TransitionProps } from "@material-ui/core/transitions/transition";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import { noOp } from "@octopusdeploy/utilities";
import * as React from "react";
import { useTransitionComponentOverride } from "~/primitiveComponents/transitions/overrideTransitions";
export type Horizontal = "left" | "center" | "right";
export type Vertical = "top" | "center" | "bottom";
export interface Origin {
    horizontal: Horizontal;
    vertical: Vertical;
}
export interface PopoverProps {
    id?: string;
    anchorEl: Element | null;
    anchorOrigin?: Origin;
    className?: string;
    onClose?: () => void;
    open: boolean;
    style?: React.CSSProperties;
    transformOrigin?: Origin;
    disableAutoFocus?: boolean;
    disableEnforceFocus?: boolean;
    getUpdatePosition?: (callback: () => void) => void;
    TransitionComponent?: React.ComponentType<TransitionProps>;
}
export const Popover: React.FC<PopoverProps> = (props) => {
    const transitionComponent = useTransitionComponentOverride() ?? props.TransitionComponent ?? Fade; // Default to the same animation used in our global search.
    const styles = {
        paper: css({
            "&&": {
                backgroundColor: themeTokens.color.menuList.background.default,
            },
        }),
    };
    return (<MuiPopover id={props.id} classes={styles} action={(actions) => (props.getUpdatePosition && actions ? props.getUpdatePosition(actions.updatePosition) : noOp())} anchorEl={props.anchorEl} anchorOrigin={props.anchorOrigin} className={props.className} onClose={props.onClose} open={props.open} style={props.style} transformOrigin={props.transformOrigin} disableAutoFocus={props.disableAutoFocus} disableEnforceFocus={props.disableEnforceFocus} TransitionComponent={transitionComponent}>
            {props.children}
        </MuiPopover>);
};
Popover.displayName = "Popover"
